import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import { requestControlledSubs } from '../../../store/visit-notes/VisitNotesActions';
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import { Link } from 'react-router';
import Moment from '../../../components/utils/Moment';
import FiltersForm from '../../management/components/ClinicActivity/FiltersForm';
import { requestUsersTypeahead } from '../../../store/users/UsersActions';
import { hostTitle } from '../../../config/ui';

class ControlledSubs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 25,
      page: 0,
      pages: -1,
      search: null,
      sorted: [],
      filtered: [],
      providers: [],
      selectedOption: 1,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.changeFilters = this.changeFilters.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  fetchData = state => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getControlledSubs({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        masterId: state.providers ? ((state.providers.masterId === undefined) ? [] : state.providers.masterId) : [],
        from: state.providers ? state.providers.from : null,
        to: state.providers ? state.providers.to : null,
        tenantId: this.props.currentUser.queryParams.tenantId,
        showValue: this.state.selectedOption
      })
      .then(response =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 10,
        order: '',
        search,
        filters: null,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) => {
            if (item.masterId) {
              options.push({
                id: item.id,
                masterId: item.masterId,
                lastName: item.lastName,
                firstName: item.firstName,
              });
            }
          });
        }
        return options;
      });
  };

  changeFilters(params) {
    this.setState({ providers: { ...this.providers, ...params } }, () => this.fetchData(this.state));
  }

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  handleChange(event) {
    this.setState({ selectedOption: event.target.value }, () =>
      this.table.fireFetchData(),
    );
  }

  render() {
    const { data } = this.props;
    return (
      <div id="content">
        <Helmet title={`Controlled Subs – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Practice Management', 'Controlled Subs']}
              icon="fa fa-fw fa-hospital-o"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Controlled Subs</h2>
                </header>
                <div style={{ padding: 10, borderBottom: '1px solid #eeeeee' }}>
                  <div className="row form-inline">
                    <div className="col-md-6 form-group">
                      <FiltersForm
                        searchUsers={this.searchUsers}
                        onSubmit={this.changeFilters}
                      />
                    </div>
                    <div className="col-md-2 form-group">
                      <span>Status: </span>
                      <select
                        className="form-control"
                        name="status"
                        value={this.state.selectedOption}
                        onChange={this.handleChange}
                      >
                        <option value="1">Show Active</option>
                        <option value="0">Show Inactive</option>
                        <option value="2">Show All</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="widget-body no-padding">
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isLoading}
                      data={this.props.data ? this.props.data.list : []}
                      onFetchData={this.fetchData}
                      columns={[
                        {
                          Header: 'Type',
                          accessor: 'type',
                          width: '60',
                        },
                        {
                          Header: 'Origin',
                          accessor: 'origin',
                          width: '100',
                        },
                        {
                          Header: 'Start Date',
                          accessor: 'startDate',
                          width: '100',
                          Cell: (row) => (
                            <Moment
                              date={row.original.startDate}
                              format="MM/DD/YYYY"
                            />
                          ),
                        },
                        {
                          Header: 'Name',
                          accessor: 'displayedName',
                          width: '250',
                          Cell: (row) => (
                            <span>
                              <label>{row.original.displayedName}</label>
                              <div
                                hidden={!row.original.controlled}
                                className="label label-danger pull-right"
                              >
                                CS
                              </div>
                            </span>
                          ),
                        },
                        {
                          Header: 'Directions',
                          accessor: 'directions',
                          width: '250',
                        },
                        {
                          Header: 'ProviderName',
                          accessor: 'masterUserId',
                          width: '150',
                          Cell: (row) =>
                            `${
                              row.original.providerName
                                ? row.original.providerName
                                : ''
                            }`,
                        },
                        {
                          Header: 'Qty/Units',
                          accessor: 'quantity',
                          width: '100',
                          Cell: (row) =>
                            `${
                              row.original.quantity ? row.original.quantity : ''
                            } ${row.original.units ? row.original.units : ''}`,
                        },
                        {
                          Header: 'Patient Id',
                          id: 'patientId',
                          accessor: 'patientId',
                          width: '120',
                        },
                        {
                          Header: 'Master Patient Id',
                          id: 'masterPatientId',
                          accessor: 'masterPatientId',
                          width: '110',
                          Cell: (row) => (
                            <span>
                              <Link
                                to={`/patients/profile/${row.original.masterPatientId}`}
                                target="_blank"
                              >
                                {row.original.masterPatientId}
                              </Link>
                            </span>
                          ),
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      filterable
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({ ...state.visitNotes, currentUser: state.currentUser }),
  (dispatch) => ({
    getControlledSubs: (params) => dispatch(requestControlledSubs(params)),
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
  }),
)(ControlledSubs);



// WEBPACK FOOTER //
// ./src/routes/management/containers/ControlledSubs.js